import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { ServiceProvidersState } from './types';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

export const state: ServiceProvidersState = {
  service_providers:[],
};


export const serviceProviders: Module<ServiceProvidersState,RootState> = {
    state,
    getters,
    actions,
    mutations
};